function sortingToOptionValue({sorting, direction}) {
    return sorting + '::' + direction;
}

export { sortingToOptionValue };